import { KeyValuePair } from 'models/technical/key-value-pair';

export function projectObjectToKeyValuePair<T1 extends number | string, T2>(
  o: any,
): KeyValuePair<T1, T2>[] {
  return Object.keys(o).map((key) => {
    return {
      key: <T1>key,
      value: <T2>o[key],
    };
  });
}
